import React, { useCallback, useContext, useState, useMemo } from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

import FormIcon from 'Assets/images/form.svg'
import Pencil from 'Assets/images/pencil.svg'
import Trash from 'Assets/images/trash.svg'

import { deleteAction, setFlowHistory } from '../../../../actions/flow'
import { StepContext } from '../../../../containers/contexts'

import MlSearch from '../edit/MlSearchModal'
import TransferChatDept from '../edit/TransferChatDept'
import PrechatForm from '../edit/PrechatForm'
import CollectInformationEdit from '../edit/CollectInformationEdit'
import HfcCollectInformationEdit from '../edit/HfcCollectInformationEdit'
import HappyFoxWorkflowEdit from '../edit/HappyFoxWorkflowEdit'
import ZapierTriggerEdit from '../edit/ZapierTriggerEdit'
import { findgoToStep } from '../../utils/findGoToStep'
import { getFlowHistory } from 'Selectors/flow'
import StepLine from '../StepLine'
import Draggable from '../Draggable'
import MlCollectUserQuestion from '../edit/MlCollectUserQuestion'

const editModeComponents = {
  ml_search: MlSearch,
  happyfoxchat_transfer_to_department: TransferChatDept,
  happyfoxchat_contact_details_form: PrechatForm,
  happyfoxchat_get_name: HfcCollectInformationEdit,
  happyfoxchat_get_email: HfcCollectInformationEdit,
  happyfoxchat_get_phone: HfcCollectInformationEdit,
  happyfoxchat_get_description: HfcCollectInformationEdit,
  happyfoxchat_get_attachments: HfcCollectInformationEdit,
  collect_information: CollectInformationEdit,
  collect_information_name: CollectInformationEdit,
  collect_information_email: CollectInformationEdit,
  collect_information_text: CollectInformationEdit,
  collect_information_text_multiline: CollectInformationEdit,
  happyfox_workflow_action: HappyFoxWorkflowEdit,
  zapier_trigger_form_submit: ZapierTriggerEdit,
  zapier_trigger_quick_reply_submit: ZapierTriggerEdit,
  default: () => null
}

const ActionPill = ({ text, actionId, editable, deletable, index }) => {
  const dispatch = useDispatch()
  const [hover, setHover] = useState(false)
  const [editMode, setEditMode] = useState(false)

  const { step, stepId, row } = useContext(StepContext)
  const settings = _.get(step, 'settings', {})
  const action = _.get(settings, `${actionId}`, {})
  const history = useSelector(getFlowHistory)

  const onDeleteClick = useCallback(() => {
    dispatch(
      deleteAction({
        stepId,
        actionId
      })
    )
    dispatch(setFlowHistory({ goToStep: stepId, row: row - 1 }))
  }, [dispatch, stepId, actionId, row])

  const mouseOverEvents = {
    onMouseOver: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }

  const onEditClick = () => setEditMode(true)
  const onCancelClick = useCallback(() => setEditMode(false), [])

  const EditComponent = editModeComponents[action.type] || editModeComponents.default

  const onPillClick = useCallback(() => {
    if (editModeComponents[action.type] === undefined) {
      return
    }
    const goToStep = findgoToStep(action)
    if (goToStep) {
      dispatch(setFlowHistory({ goToStep, row }))
    } else if (action.type !== 'ml_search') {
      setEditMode(true)
    }
  }, [action, dispatch, row])

  const goToStep = useMemo(() => findgoToStep(action), [action])
  const isStepActive = goToStep && _.split(history, '.')[row] === goToStep

  const isActive = isStepActive || hover

  return (
    <StepLine {...mouseOverEvents}>
      <Draggable drag={!editMode} id={actionId} index={index}>
        {(provided) => (
          <div
            className={classNames(
              'quote-wrapper',
              { active: isActive && action.type !== 'ml_search' },
              { 'edit-mode': editMode }
            )}
          >
            {action.type === 'ml_search' && (
              <MlCollectUserQuestion editable='true' name='collectUserQuestion' actionId={actionId} />
            )}
            {action.type !== 'ml_search' && (
              <div className='quote-item'>
                {editMode && (
                  <EditComponent mode='edit' actionId={actionId} cancelFn={onCancelClick} deleteFn={onDeleteClick} />
                )}
                {!editMode && (
                  <div className='pill-wrapper' onClick={onPillClick}>
                    <div className='pill'>
                      <div {...provided.dragHandleProps} className='icon'>
                        <FormIcon />
                      </div>
                      <div className='text'>{text}</div>
                    </div>
                    <div className={classNames('actions', { 'd-none': !isActive })}>
                      {editable && (
                        <div className='action-icon edit' onClick={onEditClick} title='edit'>
                          <Pencil height='16' width='16' />
                        </div>
                      )}
                      {deletable && (
                        <div className='action-icon' onClick={onDeleteClick} title='delete'>
                          <Trash />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </Draggable>
    </StepLine>
  )
}

export default ActionPill
